import React from "react";
import VisaSlider from "./Mainheader";
import About from "./About";
import Service from "./Service";
import Testimonial from "./Testimonial";
import Blog from "./Blog";
export default function Home() {
    return (
        <>
            <VisaSlider />
            <About />
            <Service />
           
            <Blog />
        </>
    )
}